import {reduxForm, Field, isDirty} from 'redux-form'
import SettingField from 'components/Fields/ReduxForm/SettingField'
import Header from './Header'
import {connect} from 'react-redux'
import {changeOutletName} from 'actions/setting/receipt'
import styles from './ReceiptForm.css'
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField'

const validate = (values) => {
  const FIELD_REQUIRED_ERROR = 'This field is required'
  const errors = {}
  if (!values.name) {
    errors.name = FIELD_REQUIRED_ERROR
  }

  if (!values.address) {
    errors.address = FIELD_REQUIRED_ERROR
  }

  if (!values.city) {
    errors.city = FIELD_REQUIRED_ERROR
  }

  if (!values.province) {
    errors.province = FIELD_REQUIRED_ERROR
  }

  if ((!values.zipcode) || (!/^\d{5}$/.test(values.zipcode))) {
    errors.zipcode = FIELD_REQUIRED_ERROR
  }

  if (!values.phone) {
    errors.phone = FIELD_REQUIRED_ERROR
  }

  return errors
}

class ReceiptForm extends React.Component {
  render () {
    return <form className={`${styles['wrapper']} receipt-wrapper`} onSubmit={this.props.handleSubmit} id='form-receipt'>
      <Header title='outlet info' />
      <div className={`row ${styles['field-wrapper']}`}>
        <div className='col-lg-12'>
          <div className='form-group'>
            <Field
              component={SettingField}
              className='form-control'
              name='name'
              type='text'
              maxLength='40'
              placeholder='Outlet Name'
              onChange={this._onChangeOutletName}
            />
          </div>
        </div>
        <div className='col-lg-12'>
          <div className='form-group'>
            <Field
              component={SettingField}
              className='form-control'
              name='address'
              type='text'
              maxLength='90'
              placeholder='Address'
            />
          </div>
        </div>
        <div className={`${styles['custom-receipt']} col-md-4`}>
          <div className='form-group'>
            <Field
              component={SettingField}
              className='form-control'
              name='city'
              type='text'
              maxLength='40'
              placeholder='City'
            />
          </div>
        </div>
        <div className={`${styles['custom-receipt']} col-md-4`}>
          <div className='form-group'>
            <Field
              component={SettingField}
              className='form-control'
              name='province'
              type='text'
              placeholder='State'
              maxLength='40'
            />
          </div>
        </div>
        <div className={`${styles['custom-receipt']} col-md-4`}>
          <div className='form-group'>
            <Field
              component={SettingField}
              name='zipcode'
              className='form-control'
              pattern='[0-9]{5}'
              maxLength='5'
              placeholder='Zip'
              autoCorrect='off'
              type='tel'
              autoCapitalize='off'
              positiveNumberOnly
              maxFractionDigits={0}
              spellCheck='false'
              keyboardType='numeric'
            />
          </div>
        </div>
        <div className={`${styles['custom-receipt']} col-xs-12`}>
          <div className='form-group'>
            <Field
              component={PhoneNumberField}
              name='phone'
              type='tel'
              placeholder='812'
            />
          </div>
        </div>
        <div className='col-md-12'>
          <br />
          <hr />
          <Header title='notes' />
        </div>
        <div className='col-lg-12'>
          <Field
            component='textarea'
            className='form-control'
            name='notes'
            maxLength='100'
            placeholder='Notes'
            rows='3'
          />
        </div>
        <div className='col-md-12' style={{height: 25}} />
        <div className={styles.footer}>
          <span className='pull-right'>
            <button type='submit' className='btn btn-primary'>Save</button>
          </span>
        </div>
      </div>
    </form>
  }

  _onChangeOutletName = (e) => {
    let {outlets} = this.props.data.outlet
    let {profile} = this.props.data.setting.receipt
    this.props.dispatch(changeOutletName(e.target.value, outlets, profile))
  }
}

ReceiptForm.propTypes = {

}

let mapForm = {
  form: 'checkout',
  touchOnBlur: false,
  touchOnChange: true,
  validate
}

let mapStateToProps = (state) => {
  return {
    data: {
      isDirtyForm: isDirty('checkout')(state),
      outlet: state.outlet,
      setting: {
        receipt: state.setting.receipt
      }
    }
  }
}

export default connect(mapStateToProps)(reduxForm(mapForm)(ReceiptForm))



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Receipt/ReceiptForm/ReceiptForm.js